import { SURGE_PRICE_DETAIL, SURGE_PRICE_LIST, TRANSATION_ADD,TRANSATION_LIST,  UPDATE_TRANSATION, LOADING, NOT_FOUND, TRANSATION_DETAIL, ADD_SURGE_PRICE, UPDATE_SURGE_PRICE } from "../action/type";

const initialState = {
  list: [{}],
  surgeList: [{}],
  loading:false,
  not_found:false
};
const additionalprice = function (state = initialState, action) {
  switch (action.type) {
    case LOADING:
      return { ...state, list: action.payload ,loading:true,not_found:false};
    case NOT_FOUND:
      return { ...state, list: action.payload ,loading:false,not_found:true};
    case TRANSATION_DETAIL:
      return { ...state, list: action.payload ,loading:false,not_found:false};
      case TRANSATION_LIST:
      return { ...state, list: action.payload ,loading:false,not_found:false};
      case SURGE_PRICE_LIST:
      return { ...state, surgeList: action.payload ,loading:false,not_found:false};
    case TRANSATION_ADD:
      return { ...state, list: action.payload ,loading:false,not_found:false};
    case UPDATE_TRANSATION:
      return { ...state, list: action.payload ,loading:false,not_found:false};
      case SURGE_PRICE_DETAIL:
      return { ...state, list: action.payload ,loading:false,not_found:false};
    case ADD_SURGE_PRICE:
      return { ...state, list: action.payload ,loading:false,not_found:false};
    case UPDATE_SURGE_PRICE:
      return { ...state, list: action.payload ,loading:false,not_found:false};
    default:
      return state;
  }
};

export default additionalprice;
